// isKeikkaHander has more power than isKeikkaAdmin

export function isKeikkaHandler(keikkaData, user, stepLog) {
  if (!user || !stepLog || !keikkaData) return false;

  // keikkaTilaId < 3 jolloin vastaanottajaa ei vielä ole, palautetaan isKeikkaAdmin
  if (keikkaData.tila.keikkaTilaId <= 3) return isKeikkaAdmin(keikkaData);

  // mikäli henkilö on yrityksen asiakasAdmin ja henkiö on (isPumppuAdmin || isBetoniAdmin || isLattiaAdmin)
  if (user.settings.isAnyAdmin) {
    // henkilö on keikkaHandler mikäli henkilö kuuluu yritykseen joka on ottanut tilauksen vastaan (stepLogTypeStatusId = 2)
    const handlerAsiakasId = stepLog.getStepLogTypeStatus(2).data;
    // loop asiakaslist
    if (handlerAsiakasId != null && user.asiakasList) {
      for (let i = 0; i < user.asiakasList.length; i++) {
        if (user.asiakasList[i].asiakasId == handlerAsiakasId) {
          return true;
        }
      }
    }
  }
  return false;
}

export function isKeikkaAdmin(keikkaData) {
  if (!keikkaData) return false;
  // ja mikäli henkilö on yrityksen asiakasAdmin ja henkiö on (isPumppuAdmin || isBetoniAdmin || isLattiaAdmin)
  return keikkaData.auth.isKeikkaAdmin;
}
export function isPumppuAdmin(keikkaData) {
  return keikkaData.auth.isPumppuAdmin;
}
export function isBetoniAdmin(keikkaData) {
  return keikkaData.auth.isBetoniAdmin;
}
export function isLattiaAdmin(keikkaData) {
  return keikkaData.auth.isLattiaAdmin;
}
